import React from "react";
import { IgFontFamily } from "@intelligems/ig-design-tokens";
import Stack from "@mui/material/Stack";
import { StackProps } from "@mui/material/Stack";

export const IgConsoleLog = ({ sx, ...props }: StackProps) => (
  <Stack
    spacing={0}
    sx={{
      p: 1.5,
      borderRadius: 1,
      bgcolor: "#1e1e1e",
      fontFamily: IgFontFamily.code,
      fontSize: 12,
      lineHeight: 1.6,
      color: "#d4d4d4",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      ...sx,
    }}
    {...props}
  />
);
